import React from 'react';
import { Link } from 'react-router-dom';
import { Badge } from '@/components/ui/badge';
import { fmtQ } from '@/components/po/PoLinePicker';

export const qtyOf = (byUnit) => Object.entries(byUnit || {}).map(([u, q]) => `${fmtQ(q)} ${u}`).join(' · ') || '—';

/** On-time % with a small bar — green ≥ 90, amber ≥ 70, else red; '—' when nothing is due yet. */
export const OnTime = ({ pct, testId }) => {
  if (pct == null) return <span className="text-xs text-gray-400" data-testid={testId}>Not due yet</span>;
  const tone = pct >= 90 ? 'bg-emerald-500' : pct >= 70 ? 'bg-amber-500' : 'bg-rose-500';
  return (
    <div className="flex items-center gap-2" data-testid={testId}>
      <div className="h-2 w-20 overflow-hidden rounded-full bg-gray-200"><div className={`h-full ${tone}`} style={{ width: `${Math.min(pct, 100)}%` }} /></div>
      <span className="text-xs font-semibold tabular-nums">{pct}%</span>
    </div>
  );
};

/** A supplier's POs in the period with their own on-time %, pending qty and lateness. */
export const SupplierPoRows = ({ pos, testId }) => (
  <table className="w-full text-xs" data-testid={testId}>
    <thead className="text-gray-500"><tr>
      <th className="p-1.5 text-left">PO</th><th className="p-1.5 text-left">Section</th><th className="p-1.5 text-left">Expected</th>
      <th className="p-1.5 text-right">Ordered</th><th className="p-1.5 text-right">Received</th><th className="p-1.5 text-right">Pending</th>
      <th className="p-1.5 text-left">On-time</th><th className="p-1.5 text-left">Status</th></tr></thead>
    <tbody>
      {pos.map((p) => (
        <tr key={p.po_id} className="border-t" data-testid={`${testId}-${p.po_id}`}>
          <td className="p-1.5"><Link to={`/po/${p.po_id}`} className="font-mono text-blue-700 hover:underline">{p.po_number}</Link><div className="text-[10px] text-gray-400">{p.po_date}</div></td>
          <td className="p-1.5">{p.section_name}</td>
          <td className="p-1.5">{p.expected_delivery_date || '—'}</td>
          <td className="p-1.5 text-right tabular-nums">{qtyOf(p.ordered)}</td>
          <td className="p-1.5 text-right tabular-nums">{qtyOf(p.received)}</td>
          <td className="p-1.5 text-right font-semibold tabular-nums text-amber-700">{qtyOf(p.pending)}</td>
          <td className="p-1.5"><OnTime pct={p.on_time_pct} /></td>
          <td className="p-1.5">
            {p.overdue_days > 0 && <Badge variant="outline" className="mr-1 border-rose-300 bg-rose-50 text-rose-700">{p.overdue_days}d overdue</Badge>}
            {p.late && !p.overdue_days && <Badge variant="outline" className="mr-1 border-amber-300 bg-amber-50 text-amber-800">Late</Badge>}
            <span className="text-[11px] font-semibold text-gray-600">{p.po_status.replace('_', ' ')}</span></td>
        </tr>))}
    </tbody>
  </table>
);

export default SupplierPoRows;
